import { getPivotDateRangeForInitialLoad } from 'mini-calendar-store/lib/utils/getPivotDateRangeForInitialLoad';
import { convertDateRangeToDisplayDateRange } from 'mini-calendar-events-store/lib/utils/epochTimeToDisplayDate';
import getItem from 'mini-localstorage/lib/utils/getItem';
import { today } from 'owa-datetime/lib/userDate';
import { getCalendarViewService } from 'mini-calendar-event-services/lib/services/getCalendarViewService';
import { getUserFastBootSettings } from 'mini-early-processing/lib/userFastBootSettingsUtils';
import { SELECTED_CALENDARS_KEY } from 'mini-calendar-events-store/lib/api/selectedCalendarsLocalStorageUtils';
import { measureFunctionPerf } from 'mini-performance/lib/utils/measureFunctionPerf';

export async function earlyCalendarEventsFetch() {
    const fastBootSettings = getUserFastBootSettings();
    if (fastBootSettings) {
        // Calendar logic to get the right date range and trigger network calls.
        const dateRange = getPivotDateRangeForInitialLoad(today());
        const displayDateRange = convertDateRangeToDisplayDateRange(dateRange);
        const selectedCalendars = getItem(SELECTED_CALENDARS_KEY);
        if (selectedCalendars) {
            measureFunctionPerf(
                () =>
                    Promise.all(
                        selectedCalendars?.map(folderId =>
                            getCalendarViewService(
                                displayDateRange.start,
                                displayDateRange.end,
                                folderId,
                                null,
                                true
                            )
                        )
                    ),
                'earlyCalEventsFetch'
            )();
        }
    }
}
